/**
 * ewc-bundle — ofertas por quantidade na página de produto, independente de tema.
 *
 * O widget nasce escondido no fim do body e o JS o leva para logo acima do botão de
 * compra, achando sozinho o formulário de /cart/add que o cliente de fato envia
 * (não o da gaveta, não o do upsell). A partir daí ele intercepta o envio e monta o
 * pedido: as unidades da barra escolhida (cada uma com a variante escolhida), os
 * upsells marcados e os brindes liberados — tudo pelo /cart/add.js.
 *
 * O desconto NÃO é aplicado aqui: o widget mostra a conta que o checkout vai
 * cobrar (a mesma do ofertas.py). Quem cobra é o desconto automático da loja.
 *
 * Falha aberto: qualquer erro deixa a página e o botão do tema como estavam.
 */
(function () {
  'use strict';
  if (window.EwcBundle) return;

  var SEL_PICKER = 'variant-selects,variant-radios,variant-picker,.product-variant-picker,.product-form__variants,[data-product-option],.product-form__input--dropdown,.product-form__input--pill,.product-form__input--swatch';
  var SEL_FORA = 'cart-drawer,.cart-drawer,#shopify-section-cart-drawer,#ewc-cart-root,[data-is-cart-upsell],.upsell,.upsells-container,.drawer,.cart-drawer-upsells-container,.ewc-cart';

  function el(tag, classe, texto) { var n = document.createElement(tag); if (classe) n.className = classe; if (texto != null) n.textContent = texto; return n; }
  function dinheiro(cent, fmt) {
    var v = (cent / 100).toFixed(2), p = v.split('.'), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/g, i + '.' + p[1]).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, i)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.') + ',' + p[1]).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.')).replace(/<[^>]*>/g, '');
  }
  /* o ".00" so cai quando a config pede (o app chama isso de
     showPricesWithoutDecimals); por padrao quem manda e o formato de moeda da
     loja, que e o que a referencia mostra. */
  function enxuto(t, sem) { return sem ? String(t).replace(/(\d)\.00(?!\d)/g, '$1') : String(t); }

  /* ------------------------------------------------------ formulário de compra */
  function achar(root, seletorManual) {
    if (seletorManual) { var m = document.querySelector(seletorManual); if (m) return m; }
    function temBotao(f) { return !!f.querySelector('button[name="add"],[type="submit"]'); }
    function deFora(f) { return !!(f.closest && f.closest(SEL_FORA)); }
    var comId = null, comBotao = null, qualquer = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i]; if (deFora(f) || root.contains(f)) continue;
      var id = !!f.querySelector('[name="id"]'), botao = temBotao(f);
      if (id && botao) return f;
      if (id && !comId) comId = f; if (botao && !comBotao) comBotao = f; if (!qualquer) qualquer = f;
    }
    return comBotao || comId || qualquer;
  }
  function posicionar(root, form) {
    var alvo = form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]') || form;
    if (alvo !== form && alvo.closest) alvo = alvo.closest('.product-form__buttons') || alvo;
    var subir = alvo.closest ? alvo.closest('product-form,.product-form,.product-form__buttons-wrapper') : null;
    if (subir && subir.parentNode && subir !== form.parentNode) alvo = subir;
    if (!alvo.parentNode) return false;
    alvo.parentNode.insertBefore(root, alvo);
    root.hidden = false;
    return true;
  }

  /* ------------------------------------------------------ variantes */
  function Variantes(produto) {
    this.p = produto; this.opcoes = produto.opcoes || []; this.v = produto.variantes || [];
  }
  Variantes.prototype.porOpcoes = function (escolha) {
    for (var i = 0; i < this.v.length; i++) { var ok = true; for (var j = 0; j < escolha.length; j++) if (this.v[i].opcoes[j] !== escolha[j]) { ok = false; break; } if (ok) return this.v[i]; }
    return null;
  };
  Variantes.prototype.valoresDisponiveis = function (indice, prefixo) {
    // valores da opção `indice` que existem (e estão disponíveis) dado o prefixo já escolhido
    var vistos = {}, lista = [];
    for (var i = 0; i < this.v.length; i++) {
      var ok = true; for (var j = 0; j < indice; j++) if (this.v[i].opcoes[j] !== prefixo[j]) { ok = false; break; }
      if (!ok) continue;
      var val = this.v[i].opcoes[indice];
      if (!(val in vistos)) { vistos[val] = false; lista.push(val); }
      if (this.v[i].disponivel) vistos[val] = true;
    }
    return lista.map(function (x) { return { valor: x, disponivel: vistos[x] }; });
  };
  Variantes.prototype.porId = function (id) { for (var i = 0; i < this.v.length; i++) if (String(this.v[i].id) === String(id)) return this.v[i]; return null; };

  /* ------------------------------------------------------ widget */
  function Widget(root) {
    var no = root.querySelector('[data-ewc-bundle-config]');
    var d = JSON.parse(no.textContent);
    this.root = root; this.cfg = d.cfg || {}; this.produto = d.produto; this.fmt = d.moneyFormat; this.rotas = d.rotas || {};
    this.raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || this.rotas.raiz || '/').replace(/\/?$/, '/');
    this.vars = new Variantes(this.produto);
    this.barras = this.cfg.barras || [];
    this.selecionada = Math.max(1, Math.min(this.barras.length, parseInt(this.cfg.preselecionada || 1, 10))) - 1;
    this.unidades = [];   // [barraIndex][unidade] = escolha (array de valores de opção)
    this.extras = {};     // dados de produto dos upsells/brindes por handle
    this.ocupado = false;
    this.form = achar(root, this.cfg.seletor_formulario);
    if (!this.form) throw new Error('formulário de compra não encontrado');
    this.aplicarEstilo(); this.montar();
    if (!posicionar(root, this.form)) throw new Error('não achei onde encaixar o widget');
    if (this.cfg.esconder_seletor_do_tema !== false && this.vars.v.length > 1 &&
        (this.barraTemVariante() || this.cfg.variantes_diferentes !== false)) this.esconderPicker();
    this.ligar(); this.sincronizarVariante(); this.render(); this.carregarExtras();
  }
  Widget.prototype.aplicarEstilo = function () {
    var e = this.cfg.estilo || {}, r = this.root.style;
    if (e.cor_destaque) r.setProperty('--eb-acento', e.cor_destaque);
    if (e.cor_selo) r.setProperty('--eb-selo', e.cor_selo);
    if (e.cor_selo_texto) r.setProperty('--eb-selo-texto', e.cor_selo_texto);
    if (e.fundo_barra) r.setProperty('--eb-fundo', e.fundo_barra);
    if (e.fundo_selecionada) r.setProperty('--eb-fundo-sel', e.fundo_selecionada);
    if (e.anel) r.setProperty('--eb-anel', e.anel);
    if (e.raio != null) r.setProperty('--eb-raio', e.raio + 'px');
    if (e.fonte) r.setProperty('--eb-fonte', e.fonte);
    if (e.css) { var st = el('style'); st.textContent = e.css; this.root.appendChild(st); }
  };
  Widget.prototype.esconderPicker = function () {
    var f = this.form, secao = f.closest('.shopify-section,section,[id^="shopify-section"]') || document;
    secao.querySelectorAll(SEL_PICKER).forEach(function (n) { if (!n.closest('.ewc-bundle')) n.classList.add('ewc-esconde-seletor'); });
  };
  Widget.prototype.variantePadrao = function () {
    var id = this.form.querySelector('[name="id"]'); var v = id && this.vars.porId(id.value);
    if (!v) v = this.vars.v.filter(function (x) { return x.disponivel; })[0] || this.vars.v[0];
    return v;
  };
  Widget.prototype.money = function (cent) {
    return enxuto(dinheiro(cent, this.fmt), (this.cfg.mostrar || {}).sem_decimais);
  };
  /* barra presa a uma variante: o app chama de defaultVariants, e e assim que a
     referencia monta as barras que SAO as variantes (1/2/4 Pack) */
  Widget.prototype.varianteDaBarra = function (b) {
    if (!b || b.variante == null) return null;
    return this.vars.porId(b.variante) || null;
  };
  /* alguma barra presa a variante? entao o seletor do tema sai de cena, do mesmo
     jeito que o `hideVariantPicker` do app */
  Widget.prototype.barraTemVariante = function () {
    for (var i = 0; i < this.barras.length; i++) if (this.barras[i] && this.barras[i].variante != null) return true;
    return false;
  };
  /* a variante da barra escolhida vale para o formulario do tema — na abertura
     e a cada troca de barra, senao o preco do tema fica fora do combinado */
  Widget.prototype.sincronizarVariante = function () {
    var v = this.varianteDaBarra(this.barras[this.selecionada]);
    if (!v) return;
    var idn = this.form.querySelector('[name="id"]');
    if (!idn || String(idn.value) === String(v.id)) return;
    idn.value = String(v.id);
    idn.dispatchEvent(new Event('change', { bubbles: true }));
  };
  Widget.prototype.precoUnitario = function () { var v = this.variantePadrao(); return v ? v.preco : 0; };
  Widget.prototype.compareUnitario = function () { var v = this.variantePadrao(); return v && v.compare > v.preco ? v.compare : 0; };

  Widget.prototype.montar = function () {
    var self = this, cfg = this.cfg;
    this.root.querySelectorAll(':scope > :not(script)').forEach(function (n) { n.remove(); });
    if ((cfg.estilo || {}).colunas === 1) this.root.classList.add('ewc-bundle--pilha');
    if (cfg.titulo_bloco) {
      var tit = el('div', 'ewc-bundle__titulo');
      tit.innerHTML = cfg.titulo_bloco;   /* a referencia escreve <b> no titulo */
      this.root.appendChild(tit);
    }
    this.nosBarras = [];
    this.barras.forEach(function (b, i) {
      var lab = el('label', 'ewc-bundle__barra'); lab.setAttribute('data-ewc-bar', i + 1);
      var radio = el('input'); radio.type = 'radio'; radio.name = 'ewc-bundle-bar'; radio.value = String(i);
      lab.appendChild(radio);
      /* na pilha (blockLayout vertical) a referencia poe o selo ao LADO do
         titulo, nao como balao no topo do cartao */
      var pilha = (cfg.estilo || {}).colunas === 1;
      /* A fonte de ofertas guarda o texto como `etiqueta`; configurações mais
         antigas usavam `selo`. Aceitar ambos evita que as barras existentes
         percam os SAVE 40%/SAVE 50% ao serem renderizadas. */
      var textoSelo = b.selo || b.etiqueta || '';
      var noSelo = textoSelo ? el('span', 'ewc-bundle__selo', textoSelo) : null;
      if (noSelo && !pilha) lab.appendChild(noSelo);
      var cab = el('div', 'ewc-bundle__cabeca');
      cab.appendChild(el('span', 'ewc-bundle__bolinha'));
      var vb0 = self.varianteDaBarra(b);
      var mini = b.imagem || (vb0 && vb0.imagem);
      if (mini) { var im0 = el('img'); im0.className = 'ewc-bundle__mini'; im0.src = mini; im0.alt = ''; im0.loading = 'lazy'; cab.appendChild(im0); }
      var tx = el('div', 'ewc-bundle__textos');
      var nome = el('div', 'ewc-bundle__nome'); nome.textContent = b.titulo || (b.q + ' un');
      /* Em barras verticais o selo já mora ao lado do título; nas horizontais
         ele é a faixa superior. Não duplicar o mesmo texto. */
      if (b.etiqueta && !noSelo) nome.appendChild(el('span', 'ewc-bundle__etiqueta', b.etiqueta));
      tx.appendChild(nome);
      if (noSelo && pilha) nome.appendChild(noSelo);
      if (b.subtitulo) { var sub = el('div', 'ewc-bundle__sub'); sub.innerHTML = b.subtitulo; tx.appendChild(sub); }
      cab.appendChild(tx);
      var pr = el('div', 'ewc-bundle__precos'); pr.appendChild(el('span', 'ewc-bundle__preco')); pr.appendChild(el('span', 'ewc-bundle__cheio'));
      cab.appendChild(pr); lab.appendChild(cab);
      var un = el('div', 'ewc-bundle__unidades'); lab.appendChild(un);
      var ex = el('div', 'ewc-bundle__extras'); lab.appendChild(ex);
      self.root.appendChild(lab);
      self.nosBarras.push({ lab: lab, radio: radio, preco: pr.firstChild, cheio: pr.lastChild, unidades: un, extras: ex });
      self.unidades[i] = [];
    });
    this.propriedade = el('input'); this.propriedade.type = 'hidden'; this.propriedade.name = 'properties[_ewc_bundle]'; this.propriedade.setAttribute('data-ewc-injected', '1');
    this.form.appendChild(this.propriedade);
  };

  Widget.prototype.render = function () {
    var self = this, cfg = this.cfg, p = this.precoUnitario(), cmp = this.compareUnitario();
    var usarCompare = (cfg.mostrar || {}).usar_compare_at !== false && cmp > 0;
    this.barras.forEach(function (b, i) {
      var n = self.nosBarras[i], sel = i === self.selecionada;
      n.lab.classList.toggle('is-selected', sel); n.radio.checked = sel;
      var vb = self.varianteDaBarra(b);
      var pb = vb ? vb.preco : p;
      var cb = vb ? (vb.compare > vb.preco ? vb.compare : 0) : cmp;
      var usarCb = (cfg.mostrar || {}).usar_compare_at !== false && cb > 0;
      var total = Math.round((b.total != null ? b.total : (pb * b.q) / 100) * 100);
      var cada = Math.round((b.por_unidade != null ? b.por_unidade : total / b.q / 100) * 100);
      var cheioTotal = (usarCb ? cb : pb) * b.q;
      if ((cfg.mostrar || {}).por_unidade && b.q > 1) {
        n.preco.textContent = self.money(cada) + ' each';
        var cheioCada = usarCb ? cb : pb;
        n.cheio.textContent = cheioCada > cada ? self.money(cheioCada) : '';
      } else {
        n.preco.textContent = self.money(total);
        n.cheio.textContent = cheioTotal > total ? self.money(cheioTotal) : '';
      }
      /* a barra que PERDEU a escolha precisa ser esvaziada: sem isso o
         brinde da escolha anterior fica na tela e a secao mostra a fileira
         duas vezes */
      if (sel) { self.renderUnidades(i); self.renderExtras(i); }
      else { n.unidades.innerHTML = ''; n.extras.innerHTML = ''; }
    });
    this.atualizarForm();
  };

  Widget.prototype.renderUnidades = function (i) {
    var self = this, b = this.barras[i], n = this.nosBarras[i], cont = n.unidades;
    cont.innerHTML = '';
    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;
    if (this.varianteDaBarra(b)) return;     /* a barra JA e a variante */
    var padrao = this.variantePadrao();
    for (var u = 0; u < b.q; u++) {
      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();
      var linha = el('div', 'ewc-bundle__unidade'); linha.appendChild(el('span', 'ewc-bundle__unidade-n', '#' + (u + 1)));
      this.vars.opcoes.forEach(function (nomeOpcao, k) {
        var escolha = self.unidades[i][u];
        var valores = self.vars.valoresDisponiveis(k, escolha);
        var swatch = self.cfg.swatches && self.cfg.swatches.opcao && self.cfg.swatches.opcao.toLowerCase() === String(nomeOpcao).toLowerCase() && self.cfg.swatches.cores;
        if (swatch) {
          var grupo = el('div', 'ewc-bundle__swatches'); grupo.setAttribute('role', 'radiogroup'); grupo.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) {
            var s = el('span', 'ewc-bundle__swatch'); s.title = x.valor; s.style.background = self.cfg.swatches.cores[x.valor] || '#ccc';
            s.classList.toggle('is-on', escolha[k] === x.valor); s.classList.toggle('is-off', !x.disponivel);
            s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-val', x.valor); s.setAttribute('data-ewc-un', u);
            grupo.appendChild(s);
          });
          linha.appendChild(grupo);
        } else {
          if (u === 0) linha.appendChild(el('span', 'ewc-bundle__opcao-nome', String(nomeOpcao).replace(/:?\s*$/, ':')));
          var s = el('select'); s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-un', u); s.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Sold out)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });
          s.value = escolha[k];
          linha.appendChild(s);
        }
      });
      cont.appendChild(linha);
    }
  };

  /* A fileira do brinde/upsell tem DUAS linhas, como a do app: em cima o
     item (marcador, miniatura e nome) e embaixo o preco. O preco e dinheiro
     — a referencia escreve `£0.00`, nao a palavra FREE — em vermelho, com o
     valor cheio riscado ao lado. Quem decide se as duas linhas empilham ou
     ficam lado a lado e a folha: barra em duas colunas empilha, pilha poe o
     preco a direita. */
  Widget.prototype.linhaExtra = function (dados) {
    var tag = dados.marcavel ? 'label' : 'div';
    var linha = el(tag, 'ewc-bundle__extra' + (dados.travado ? ' is-locked' : ''));
    var main = el('div', 'ewc-bundle__extra-main');
    if (dados.marcavel) {
      var cb = el('input'); cb.type = 'checkbox';
      cb.setAttribute('data-ewc-upsell', dados.handle);
      cb.checked = !!dados.marcado;
      main.appendChild(cb);
    }
    if (dados.imagem) {
      var im = el('img'); im.className = 'ewc-bundle__extra-img';
      im.src = dados.imagem; im.alt = ''; im.loading = 'lazy';
      main.appendChild(im);
    }
    main.appendChild(el('span', 'ewc-bundle__extra-nome', dados.nome));
    linha.appendChild(main);

    var precos = el('div', 'ewc-bundle__extra-precos');
    precos.appendChild(el('span', 'ewc-bundle__extra-preco', dados.preco));
    if (dados.cheio) precos.appendChild(el('span', 'ewc-bundle__cheio', dados.cheio));
    linha.appendChild(precos);
    return linha;
  };

  Widget.prototype.renderExtras = function (i) {
    var self = this, n = this.nosBarras[i], cont = n.extras; cont.innerHTML = '';
    var zero = this.cfg.textos && this.cfg.textos.gratis ? this.cfg.textos.gratis : this.money(0);
    var ups = (this.cfg.upsells || []).filter(function (u) { return !u.por_barra || !u.por_barra.length || u.por_barra.indexOf(i + 1) !== -1; });
    ups.forEach(function (u) {
      var d = self.extras[u.handle];
      var cmpU = u.compare != null ? Math.round(u.compare * 100) : (d && d.compare);
      cont.appendChild(self.linhaExtra({
        marcavel: true, handle: u.handle,
        marcado: !!u.pre_marcado || (self.marcados && self.marcados[u.handle] === true),
        imagem: d && d.imagem,
        nome: u.texto || (d ? d.titulo : u.handle),
        preco: u.gratis ? zero : (d ? self.money(d.preco) : ''),
        cheio: cmpU ? self.money(cmpU) : ''
      }));
    });
    (this.cfg.brindes || []).forEach(function (g) {
      /* `no_bloco`: o brinde ja aparece no bloco "Gifts Included" clonado da
         referencia, que fica ABAIXO das barras. Desenhar outra vez dentro do
         cartao mostraria a mesma coisa duas vezes — ele entra no pedido e nao
         na tela. */
      if (g.no_bloco) return;
      var livre = (i + 1) >= (g.a_partir_da_barra || 1);
      var d = self.extras[g.handle];
      var linha = self.linhaExtra({
        marcavel: false, travado: !livre,
        imagem: d && d.imagem,
        nome: d ? d.titulo : g.handle,
        preco: livre ? (g.rotulo || zero) : (self.cfg.textos && self.cfg.textos.travado || 'Locked'),
        cheio: d && d.compare ? self.money(d.compare) : ''
      });
      linha.setAttribute('data-ewc-gift', g.handle);
      cont.appendChild(linha);
    });
  };

  Widget.prototype.carregarExtras = function () {
    var self = this, handles = [];
    (this.cfg.upsells || []).concat(this.cfg.brindes || []).forEach(function (x) { if (x.handle && handles.indexOf(x.handle) === -1) handles.push(x.handle); });
    handles.forEach(function (h) {
      fetch(self.raiz + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        self.extras[h] = { titulo: p.title, preco: v ? v.price : 0, compare: v && v.compare_at_price > v.price ? v.compare_at_price : (v && v.price === 0 && v.compare_at_price ? v.compare_at_price : 0),
                           variante: v ? v.id : null, imagem: (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_64x64$1$2') };
        self.renderExtras(self.selecionada);
      }).catch(function () {});
    });
  };

  Widget.prototype.itens = function () {
    var b = this.barras[this.selecionada], contagem = {}, ordem = [];
    var padrao = this.varianteDaBarra(b) || this.variantePadrao();
    for (var u = 0; u < b.q; u++) {
      var v = (this.varianteDaBarra(b) || this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) ? padrao : (this.vars.porOpcoes(this.unidades[this.selecionada][u] || padrao.opcoes) || padrao);
      if (!(v.id in contagem)) { contagem[v.id] = 0; ordem.push(v.id); }
      contagem[v.id]++;
    }
    var itens = ordem.map(function (id) { return { id: parseInt(id, 10), quantity: contagem[id], properties: { _ewc_bundle: b.titulo || String(b.q) } }; });
    var self = this, jaVai = {};
    var porHandle = {};
    (this.cfg.upsells || []).forEach(function (u) { if (u.handle) porHandle[u.handle] = u; });
    this.root.querySelectorAll('[data-ewc-upsell]:checked').forEach(function (cb) {
      var h = cb.getAttribute('data-ewc-upsell'), d = self.extras[h], u = porHandle[h] || {};
      var vid = u.variante_id || (d && d.variante);
      if (!vid) return;
      /* a fileira promete "x2 Travel Pumps": a quantidade do pedido tem de
         dizer a mesma coisa */
      itens.push({ id: parseInt(vid, 10), quantity: Math.max(1, parseInt(u.quantidade || 1, 10)), properties: { _ewc_upsell: '1' } });
      jaVai[h] = true;
    });
    (this.cfg.brindes || []).forEach(function (g) {
      if ((self.selecionada + 1) < (g.a_partir_da_barra || 1)) return;
      /* brinde e upsell do mesmo produto ficam em linhas separadas (propriedades
         diferentes): gift x1 gratis + upsell x1 pago */
      var vid = g.variante_id || (self.extras[g.handle] && self.extras[g.handle].variante);
      if (vid) itens.push({ id: parseInt(vid, 10), quantity: Math.max(1, parseInt(g.quantidade || 1, 10)), properties: { _ewc_gift: '1' } });
    });
    return itens;
  };

  Widget.prototype.atualizarForm = function () {
    var b = this.barras[this.selecionada]; this.propriedade.value = b.titulo || String(b.q);
    var distintos = {}; this.itens().forEach(function (i) { if (!i.properties._ewc_upsell && !i.properties._ewc_gift) distintos[i.id] = 1; });
    var multi = Object.keys(distintos).length > 1 || b.q > 1;
    this.form.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var sec = this.form.closest('.shopify-section,section'); if (sec) sec.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var bd = this.cfg.botao_dinamico;
    if (bd && bd.modelo) {
      var btn = this.form.querySelector('button[name="add"],[type="submit"]');
      var alvo = btn && (btn.querySelector('span') || btn);
      if (alvo) {
        if (!btn.hasAttribute('data-ewc-texto-original')) btn.setAttribute('data-ewc-texto-original', alvo.textContent);
        var total = Math.round((b.total != null ? b.total : this.precoUnitario() * b.q / 100) * 100);
        var cheio = (this.compareUnitario() || this.precoUnitario()) * b.q;
        var economia = Math.max(0, cheio - total);
        var novo = economia > 0 ? bd.modelo.replace('{{economia}}', this.money(economia)) : btn.getAttribute('data-ewc-texto-original');
        if (alvo.textContent !== novo) alvo.textContent = novo;
      }
    }
  };

  Widget.prototype.ligar = function () {
    var self = this;
    this.root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.name === 'ewc-bundle-bar') {
        self.selecionada = parseInt(t.value, 10);
        self.sincronizarVariante();
        self.render(); return;
      }
      if (t.tagName === 'SELECT' && t.hasAttribute('data-ewc-opt')) {
        var k = parseInt(t.getAttribute('data-ewc-opt'), 10), u = parseInt(t.getAttribute('data-ewc-un'), 10);
        var esc = self.unidades[self.selecionada][u]; esc[k] = t.value;
        for (var j = k + 1; j < self.vars.opcoes.length; j++) { var vals = self.vars.valoresDisponiveis(j, esc); if (!vals.some(function (x) { return x.valor === esc[j]; })) esc[j] = (vals.filter(function (x) { return x.disponivel; })[0] || vals[0] || {}).valor; }
        self.renderUnidades(self.selecionada); self.atualizarForm(); return;
      }
      if (t.hasAttribute('data-ewc-upsell')) { self.marcados = self.marcados || {}; self.marcados[t.getAttribute('data-ewc-upsell')] = t.checked; self.atualizarForm(); }
    });
    this.root.addEventListener('click', function (ev) {
      var barra = ev.target.closest && ev.target.closest('.ewc-bundle__barra');
      if (barra && !ev.target.closest('select,input,button,a')) {
        var indice = parseInt(barra.getAttribute('data-ewc-bar'), 10) - 1;
        if (indice >= 0 && indice < self.barras.length && indice !== self.selecionada) {
          self.selecionada = indice;
          self.sincronizarVariante();
          self.render();
        }
        return;
      }
      var s = ev.target.closest && ev.target.closest('.ewc-bundle__swatch'); if (!s) return;
      ev.preventDefault();
      var k = parseInt(s.getAttribute('data-ewc-opt'), 10), u = parseInt(s.getAttribute('data-ewc-un'), 10);
      self.unidades[self.selecionada][u][k] = s.getAttribute('data-ewc-val');
      self.renderUnidades(self.selecionada); self.atualizarForm();
    });
    this.form.addEventListener('submit', function (ev) {
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); self.comprar();
    }, true);
    this.form.setAttribute('data-ewc-bundle-form', '1');
    var self2 = this; window.addEventListener('pageshow', function () { self2.ocupado = false; var btn = self2.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = false; });
  };

  Widget.prototype.comprar = function () {
    var self = this; if (this.ocupado) return; this.ocupado = true;
    var btn = this.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = true;
    var itens = this.itens();
    fetch(this.raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ewc:cart:added', { bubbles: true, detail: { items: json.items || [json] } }));
        var depois = self.cfg.depois_de_adicionar || 'gaveta';
        if (depois === 'carrinho' || (depois === 'gaveta' && !window.EwcCart)) {
          ['cart:refresh', 'cart:build', 'cart-drawer:open', 'ajaxProduct:added'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
          if (depois === 'carrinho' || !document.querySelector('cart-drawer,.cart-drawer,[data-cart-drawer]')) window.location.href = self.rotas.carrinho || (self.raiz + 'cart');
        }
      })
      .catch(function () { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); })
      .then(function () { self.ocupado = false; if (btn) btn.disabled = false; });
  };

  function iniciar() {
    document.querySelectorAll('[data-ewc-bundle]').forEach(function (root) {
      if (root._ewc) return;
      try { root._ewc = new Widget(root); window.EwcBundle = root._ewc; } catch (e) { root.hidden = true; if (window.console && console.debug) console.debug('[ewc-bundle] fora do ar:', e.message); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
